<template>
    <span class="fit-text">
      <slot></slot>
    </span>
</template>

<script>
export default {
  name: 'fit-text',
  props: {
    max: {
      default: 16,
      type: Number
    },
    stepSize: {
      default: 0.25,
      type: Number
    },
    changed: {
      type: Function
    }
  },
  data () {
    return {
      observer: null
    }
  },
  methods: {
    calculate () { // Fit text to container size
      const element = this.$el
      let fontSize = this.max + 1

      element.style.fontSize = `${fontSize}px`

      for (let i = this.max * (1 / this.stepSize); i > 1 && element.offsetWidth > element.parentElement.offsetWidth; i -= 1) {
        fontSize -= this.stepSize
        element.style.fontSize = `${fontSize}px`
      }

      fontSize -= 1
      element.style.fontSize = `${fontSize}px`
    }
  },
  mounted () {
    this.calculate()
    if ('MutationObserver' in window && this.observer === null) {
      this.observer = new MutationObserver(this.calculate)
      this.observer.observe(
        this.$el,
        { subtree: true, characterData: true }
      )
    }
  },
  beforeDestroy () {
    this.observer.disconnect()
  }
}
</script>

<style lang="sass" scoped>
.fit-text
  display: inline-block
</style>
